import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    createChannel = new Subject();
    updateChannel = new Subject()
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.updateChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }

    fetchUpdate = async (query) => {
        try {
            this.updateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdate(query).then((result) => {
                this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }

}

export default CreateBloc